import { useFilterOptions } from '../../common/hooks/useFilterOptions';
import { useState } from 'react';
import { useShops } from '../../common/hooks/useShops';
import { Filter } from '@increasecard/typed-components/dist/types/Filter';
import { useTranslation } from 'react-i18next';
import { compareOptionsByName } from '../../utils/filtersUtils';
import moment from 'moment';

export type Filters = Record<string, Filter>;

export function useChargebacksScreen() {
  const filterOptions = useFilterOptions();
  const { t } = useTranslation();
  const [filters, setFilters] = useState<Filters>({});
  const [dateRangeInput, setDateRangeInput] = useState([
    moment()
      .subtract(30, 'days')
      .toDate(),
    new Date()
  ]);
  const shops = useShops();

  return {
    filters,
    setFilters,
    dateRangeInput,
    setDateRangeInput,
    filterFields: filterOptions
      ? [
          {
            displayName: t('common:filters:shops:displayName'),
            name: 'shop_id',
            type: 'selectMultiple',
            options: shops
              ? shops
                  .map((shop) => ({ name: shop.name, value: shop.id }))
                  .sort(compareOptionsByName)
              : [],
            hasSearch: true,
            hasClearButton: true
          },
          {
            displayName: t('common:filters:cardBrand:displayName'),
            name: 'card_brand',
            type: 'selectMultiple',
            options: [
              ...filterOptions.cardBrands.map((id) => {
                return {
                  value: id,
                  name: t(`common:cardBrands:${id}`)
                };
              })
            ]
          },
          {
            name: 'info_provider',
            displayName: t('common:filters:processor:displayName'),
            type: 'select',
            options: filterOptions.processorNames
              .map((id) => ({
                name: t(`common:processorNames:${id}`),
                value: id
              }))
              .sort(compareOptionsByName)
          },
          {
            name: 'category',
            displayName: t('common:filters:chargebackCategories:displayName'),
            type: 'select',
            options: [
              { value: ' ', name: t('common:filters:chargebackCategories:selectAll') },
              ...filterOptions.chargebackCategories.map((category) => {
                return {
                  value: category,
                  name: t(`common:filters:chargebackCategories:${category}`)
                };
              })
            ]
          },
          {
            name: 'status',
            displayName: t('common:filters:chargebackStatus:displayName'),
            type: 'select',
            options: [
              { value: ' ', name: t('common:filters:chargebackStatus:selectAll') },
              ...filterOptions.chargebackStatuses.map((status) => {
                return {
                  value: status,
                  name: t(`common:filters:chargebackStatus:${status.toLowerCase()}`)
                };
              })
            ]
          }
        ]
      : []
  };
}
